import { Component, ErrorInfo, ReactNode } from 'react';
import i18n from '../app/localization';
import LogoMacRADesignNegative from '../app/images/logo_macread_negativo.png';
import LogoMaccaferri from '../app/images/LogoMaccaferri.svg';
import Button from '../components/Button/Button';
import './ErrorBoundary.scss';
import { logError } from '../app/utils/utils';
interface IProps {
    children: ReactNode;
    navigate: (path?: string) => void;
}

interface IState {
    hasError: boolean;
}

class ErrorBoundary extends Component<IProps, IState> {
    public state: IState = {
        hasError: false,
    };

    public static getDerivedStateFromError(_: Error): IState {
        return { hasError: true };
    }

    public componentDidCatch(error: Error, errorInfo: ErrorInfo) {
        // You can also log the error to an error reporting service
        logError('ErrorBoundary', 'Uncaught error:', { error, errorInfo });
    }

    handleGotoHome = () => {
        this.props.navigate();
        window.location.replace(window.location.origin);
        window.location.reload();
    };

    public render() {
        if (this.state.hasError) {
            const { t } = i18n;
            return (
                <header id="HeaderMacro1">
                    <div className="head">
                        <div className="leftHead">
                            <img className="logoMacra" src={LogoMacRADesignNegative} alt="Maccaferri logo header" />
                            <span className="title">
                                <h5>{t('header_title')}</h5>
                            </span>
                        </div>
                        <a className="backToHub" href={process.env.REACT_APP_EDESIGN_PORTAL_URL}>
                            {t('header_back_to_hub')}
                        </a>
                        <img
                            className="cursor-pointer logoMaccaferri"
                            src={LogoMaccaferri}
                            alt="Logo Maccaferri"
                            onClick={this.handleGotoHome}
                            onKeyDown={e => {
                                if (e.key === 'Enter' || e.key === ' ') {
                                    this.handleGotoHome();
                                }
                            }}
                            tabIndex={0}
                            role="button"
                        />
                    </div>
                    <div className="error-boundary">
                        <h1>{t('error_page_msg')}</h1>
                        <Button className="d-flex justify-content-end mb-3" onClick={this.handleGotoHome}>
                            {t('header_label_home')}
                        </Button>
                    </div>
                </header>
            );
        }
        return this.props.children;
    }
}

export default ErrorBoundary;
